// ShortsCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import { EMPTY_ARRAY } from '../resource/defaults.js';
import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import DiscoverShowMoreWrapper from '../component/DiscoverShowMoreWrapper.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'shorts-categories',
  categoryType: 'shorts',
  loaderName: 'ShortsCategoriesCategory',
});

const ShortsCategoriesCategoryRoute = () => {
  const { data, error, meta = EMPTY_ARRAY } = useLoaderData();

  useSSRDataMerge({
    componentName: 'ShortsCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <DiscoverShowMoreWrapper isShorts />
    </>
  );
};

export default ShortsCategoriesCategoryRoute;
